module.exports = __webpack_public_path__ + "media/landing_page/instacart-aa-lockup-149a0be1.svg";